import { DocumentCard } from "@fluentui/react";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { useContext, useMemo } from "react";
import { HealthViewFiltersContext } from "../../../pages/ExploreHealth";
import { HEALTH_VIEW_DATA } from "../Common/HealthView.constants";

export const HealthViewTabsContainer = () => {
  const {
    pivotItems
  } = HEALTH_VIEW_DATA.TABS.DATA;
  const filters = useContext(HealthViewFiltersContext);

  const overviewTabItem =
    pivotItems.find(({ headerText }) => headerText === "Overview") || pivotItems[0];
  const mtpTabItem =
    pivotItems.find(({ headerText }) => headerText === "MTP") ||
    pivotItems.find(({ headerText }) => headerText === "Microsoft Threat Protection");
  const purviewTabItem =
    pivotItems.find(({ headerText }) => headerText === "Purview");
  const intuneTabItem =
    pivotItems.find(({ headerText }) => headerText === "Intune");

  const selectedComponent = useMemo(() => {
    const normalizedProductFamily = (filters?.productFamily || "")
      .split(";")
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean);

    if (normalizedProductFamily.includes("mtp") && mtpTabItem?.component) {
      return mtpTabItem.component;
    }

    if (normalizedProductFamily.includes("purview") && purviewTabItem?.component) {
      return purviewTabItem.component;
    }

    if (normalizedProductFamily.includes("intune") && intuneTabItem?.component) {
      return intuneTabItem.component;
    }

    return overviewTabItem?.component;
  }, [filters?.productFamily, mtpTabItem, purviewTabItem, intuneTabItem, overviewTabItem]);

  return (
    <DocumentCard styles={{ root: { maxWidth: "", padding: 10, boxShadow: "var(--customShimmerShadow4)" } }}>
      <FluentProvider theme={webLightTheme}>
        {selectedComponent ? selectedComponent() : null}
      </FluentProvider>
    </DocumentCard>
  );
};
